module.exports = __webpack_public_path__ + "static/media/ArrowRight.3e731cc4.svg";